import { axiosV4 } from "../../../Utils/Axios/axiosV4";

export const getKonkurBookletCategoriesService = async (
  userToken: string,
  yearId: string | number
) => {
  return axiosV4.get(`/user/konkur-booklets/categories?konkur_booklet_year_id=${yearId}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
